import React from 'react'
import { MerchantLocationsLoader } from 'router/Loaders'
import { MerchantIntegrationsLoader } from 'router/Loaders/MerchantIntegrationsLoader'
import { ManageIntegrations } from 'components/Integrations/Manage'
import IntegrationModuleLoaders from 'router/Loaders/PartnerDataLoaders'

export const ManageIntegrationsWrapper = () => {
  return (
    <MerchantLocationsLoader>
      {(isParentLoaded) => (
        <MerchantIntegrationsLoader isParentLoaded={isParentLoaded}>
          {(isLoaded) => (
            <IntegrationModuleLoaders isParentLoaded={isLoaded}>
              <ManageIntegrations />
            </IntegrationModuleLoaders>
          )}
        </MerchantIntegrationsLoader>
      )}
    </MerchantLocationsLoader>
  )
}
